"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedProjectExplorer = void 0;
var React = require("react");
var NestedProjectExplorerCell_1 = require("./dataGridCells/NestedProjectExplorerCell");
var DestinationItem_1 = require("./DestinationItem");
var NestedItemsFractalRowStore_1 = require("./NestedItemsFractalRowStore");
var TreeViewComponent_1 = require("./TreeViewComponent");
// We could call setItems() on the row store instead of creating a whole new one, but this is not
// optimized because we currently don't have the use case of sending in new projects.
function buildRowStore(items, topLevelDestinationStatus, rowExpansionHandler) {
    var personalSpace;
    var treeNoPersonalSpace = [];
    items.forEach(function (roseTree) {
        if (roseTree.node.itemType === DestinationItem_1.DestinationItemType.personalSpace) {
            personalSpace = roseTree.node;
        }
        else {
            treeNoPersonalSpace.push(roseTree);
        }
    });
    return personalSpace ?
        new NestedItemsFractalRowStore_1.NestedItemsFractalRowStore(treeNoPersonalSpace, rowExpansionHandler, topLevelDestinationStatus, personalSpace) :
        new NestedItemsFractalRowStore_1.NestedItemsFractalRowStore(items, rowExpansionHandler, topLevelDestinationStatus);
}
var CellFormatterFactory = (0, NestedProjectExplorerCell_1.getDestinationProjectCellFormatter)();
var NestedProjectExplorer = /** @class */ (function (_super) {
    __extends(NestedProjectExplorer, _super);
    function NestedProjectExplorer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedProjectId: _this.props.initiallySelectedProjectId || null,
        };
        _this.rowExpansionHandler = function (rowKey) {
            _this.rowStore.toggleExpansionForItemKey(rowKey);
            _this.forceUpdate();
        };
        _this.rowStore = buildRowStore(_this.props.projects, _this.props.topLevelDestinationStatus, _this.rowExpansionHandler);
        _this.handleItemClicked = function (newProject) {
            if (newProject.status !== 'valid') {
                return;
            }
            var currentSelectedId = _this.state.selectedProjectId;
            var rowAlreadySelected = currentSelectedId !== null && currentSelectedId === newProject.id;
            if (rowAlreadySelected) {
                _this.setState({ selectedProjectId: null });
                _this.props.onSelectedProjectChanged(null);
            }
            else {
                _this.setState({ selectedProjectId: newProject.id });
                _this.props.onSelectedProjectChanged(newProject);
            }
        };
        return _this;
    }
    NestedProjectExplorer.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, projects = _a.projects, topLevelDestinationStatus = _a.topLevelDestinationStatus;
        if (projects !== prevProps.projects || topLevelDestinationStatus !== prevProps.topLevelDestinationStatus) {
            this.rowStore = buildRowStore(projects, topLevelDestinationStatus, this.rowExpansionHandler);
            this.forceUpdate();
        }
    };
    NestedProjectExplorer.prototype.render = function () {
        // tslint:disable-next-line:max-line-length
        var _a = this.props, initiallySelectedProjectId = _a.initiallySelectedProjectId, keepParentsOfSelectedItemExpanded = _a.keepParentsOfSelectedItemExpanded, onSelectedProjectChanged = _a.onSelectedProjectChanged, selectRowOnExpansion = _a.selectRowOnExpansion, projects = _a.projects, topLevelDestinationStatus = _a.topLevelDestinationStatus, htmlProps = __rest(_a, ["initiallySelectedProjectId", "keepParentsOfSelectedItemExpanded", "onSelectedProjectChanged", "selectRowOnExpansion", "projects", "topLevelDestinationStatus"]);
        return React.createElement(TreeViewComponent_1.TreeViewComponent, __assign({}, htmlProps, { cellFormatter: CellFormatterFactory, keepParentsOfSelectedItemExpanded: keepParentsOfSelectedItemExpanded, onItemClicked: this.handleItemClicked, rowStore: this.rowStore, selectRowOnExpansion: selectRowOnExpansion, selectedItemId: this.state.selectedProjectId }));
    };
    NestedProjectExplorer.defaultProps = {
        keepParentsOfSelectedItemExpanded: true,
        selectRowOnExpansion: true,
    };
    return NestedProjectExplorer;
}(React.PureComponent));
exports.NestedProjectExplorer = NestedProjectExplorer;
//# sourceMappingURL=NestedProjectExplorerComponent.js.map